import { Routes, Route as RouteItem, useNavigate } from "react-router-dom";
import Layout from "../components/layout/Layout";
import User from "../features/user/User";
import CreateUser from "../features/user/CreateUser";
import RippleButton from "../components/common/RippleButton";
import Menu from "../features/menu/Menu";
import Rights from "../features/rights/Rights";
import UserType from "../features/userType/UserType";
import CreateUserType from "../features/userType/CreateUserType";
import { PrivateLoginRoute, PrivateRoute } from "./PrivateRoute";
import Inquiry from "../features/inquiry/Inquiry";
// import CreateInquiry from "../features/inquiry/CreateInquiry";
import Testimonial from "../features/testimonial/Testimonial";
import SeoTag from "../features/seotag/SeoTag";
import CreateSeoTag from "../features/seotag/CreateSeoTag";
import Banner from "../features/banner/Banner";
import CreateBanner from "../features/banner/CreateBanner";
import Blog from "../features/blog/Blog";
import CreateBlog from "../features/blog/CreateBlog";
import FAQ from "../features/faq/FAQ";
import CreateFAQ from "../features/faq/CreateFAQ";
import CMS from "../features/cms/CMS";
import CreateCMS from "../features/cms/CreateCMS";
import LoginNew from "../features/login/Login";
import Setting from "../features/setting/Setting";
import Dashboard from "../features/dashboard/Dashboard";
import Facility from "../features/facility/Facility";
import WhyChoose from "../features/whychoose/WhyChoose";
import Amenities from "../features/amenities/Amenities";
import TourType from "../features/tourtype/TourType";
import Activities from "../features/activities/Activities";
import CreateActivity from "../features/activities/CreateActivity";
import Gallery from "../features/gallery/Gallery";
import Room from "../features/room/Room";
import CreateRoom from "../features/room/CreateRoom";
import SignatureMoment from "../features/signaturemoment/SignatureMoment";
import Experience from "../features/experience/Experience";
import Philosophy from "../features/philosophy/Philosophy";
import CreatePhilosophy from "../features/philosophy/CreatePhilosophy";
import WeddingVenue from "../features/weddingvenue/WeddingVenue";
import CreateWeddingVenue from "../features/weddingvenue/CreateWeddingVenue";
import Ideal from "../features/ideal/Ideal";
import CreateIdeal from "../features/ideal/CreateIdeal";
import Attractions from "../features/attraction/Attractions";
import CreateAttractions from "../features/attraction/CreateAttractions";
import Newsletter from "../features/newsletter/Newsletter";
import BookingReference from "../features/bookingReference/BookingReference";
import Package from "../features/package/Package";
import CreatePackage from "../features/package/CreatePackage";
import Position from "../features/position/Position";
import JobApplication from "../features/jobapplication/JobApplication";
import VideoGallery from "../features/videogallery/VideoGallery";
import Popup from "../features/popup/Popup";
import Dining from "../features/dining/Dining";
import CreateDining from "../features/dining/CreateDining";
import EventSpace from "../features/eventspace/EventSpace";
import CreateEventSpace from "../features/eventspace/CreateEventSpace";
import GalleryType from "../features/gallerytype/GalleryType";
import Offer from "../features/offer/Offer";
import CreateOffer from "../features/offer/CreateOffer";
import Event from "../features/event/Event";
import CreateEvent from "../features/event/CreateEvent";

const MainRouter = () => {
  const navigate = useNavigate();
  return (
    <Routes>
      <RouteItem
        path="login"
        element={
          <PrivateLoginRoute>
            <LoginNew />
          </PrivateLoginRoute>
        }
      />
      <RouteItem
        path="/"
        element={
          <PrivateRoute>
            <Layout />
          </PrivateRoute>
        }
      >
        <RouteItem index={true} element={<Dashboard />} />
        <RouteItem path="menu" element={<Menu />} />
        <RouteItem path="rights" element={<Rights />} />
        <RouteItem path="user" element={<User />} />
        <RouteItem path="user/create" element={<CreateUser />} />
        <RouteItem path="user/edit" element={<CreateUser />} />
        <RouteItem path="testimonial" element={<Testimonial />} />
        <RouteItem path="facilities" element={<Facility />} />
        <RouteItem path="whychoose" element={<WhyChoose />} />
        <RouteItem path="amenities" element={<Amenities />} />
        <RouteItem path="position" element={<Position />} />
        <RouteItem path="jobapplication" element={<JobApplication />} />
        <RouteItem path="tourtype" element={<TourType />} />
        <RouteItem path="gallery" element={<Gallery />} />
        <RouteItem path="videogallery" element={<VideoGallery />} />
        <RouteItem path="room" element={<Room />} />
        <RouteItem path="room/create" element={<CreateRoom />} />
        <RouteItem path="room/edit" element={<CreateRoom />} />
        <RouteItem path="gallerytype" element={<GalleryType />} />
        <RouteItem path="offer" element={<Offer />} />
        <RouteItem path="offer/create" element={<CreateOffer />} />
        <RouteItem path="offer/edit" element={<CreateOffer />} />

        <RouteItem path="activities" element={<Activities />} />
        <RouteItem path="activities/create" element={<CreateActivity />} />
        <RouteItem path="activities/edit" element={<CreateActivity />} />

        <RouteItem path="event" element={<Event />} />
        <RouteItem path="event/create" element={<CreateEvent />} />
        <RouteItem path="event/edit" element={<CreateEvent />} />

        <RouteItem path="banner" element={<Banner />} />
        <RouteItem path="banner/create" element={<CreateBanner />} />
        <RouteItem path="banner/edit" element={<CreateBanner />} />

        <RouteItem path="seotag" element={<SeoTag />} />
        <RouteItem path="seotag/create" element={<CreateSeoTag />} />
        <RouteItem path="seotag/edit" element={<CreateSeoTag />} />

        <RouteItem path="blog" element={<Blog />} />
        <RouteItem path="blog/create" element={<CreateBlog />} />
        <RouteItem path="blog/edit" element={<CreateBlog />} />

        <RouteItem path="faq" element={<FAQ />} />
        <RouteItem path="faq/create" element={<CreateFAQ />} />
        <RouteItem path="faq/edit" element={<CreateFAQ />} />

        <RouteItem path="cms" element={<CMS />} />
        <RouteItem path="cms/edit" element={<CreateCMS />} />
        <RouteItem path="cms/create" element={<CreateCMS />} />
        <RouteItem path="usertype" element={<UserType />} />
        <RouteItem path="usertype/create" element={<CreateUserType />} />
        <RouteItem path="usertype/edit" element={<CreateUserType />} />
        <RouteItem path="inquiry" element={<Inquiry />} />
        <RouteItem path="setting" element={<Setting />} />
        <RouteItem path="signaturemoment" element={<SignatureMoment />} />
        <RouteItem path="philosophy" element={<Philosophy />} />
        <RouteItem path="philosophy/create" element={<CreatePhilosophy />} />
        <RouteItem path="philosophy/edit" element={<CreatePhilosophy />} />
        <RouteItem path="experience" element={<Experience />} />
        <RouteItem path="weddingvenue" element={<WeddingVenue />} />
        <RouteItem
          path="weddingvenue/create"
          element={<CreateWeddingVenue />}
        />
        <RouteItem path="weddingvenue/edit" element={<CreateWeddingVenue />} />
        <RouteItem path="ideal" element={<Ideal />} />
        <RouteItem path="ideal/create" element={<CreateIdeal />} />
        <RouteItem path="ideal/edit" element={<CreateIdeal />} />
        <RouteItem path="attractions" element={<Attractions />} />
        <RouteItem path="attractions/create" element={<CreateAttractions />} />
        <RouteItem path="attractions/edit" element={<CreateAttractions />} />
        <RouteItem path="newsletter" element={<Newsletter />} />
        <RouteItem path="bookingreference" element={<BookingReference />} />
        <RouteItem path="popup" element={<Popup />} />
        <RouteItem path="package" element={<Package />} />
        <RouteItem path="package/create" element={<CreatePackage />} />
        <RouteItem path="package/edit" element={<CreatePackage />} />
        <RouteItem path="dining" element={<Dining />} />
        <RouteItem path="dining/create" element={<CreateDining />} />
        <RouteItem path="dining/edit" element={<CreateDining />} />
        <RouteItem path="eventspace" element={<EventSpace />} />
        <RouteItem path="eventspace/create" element={<CreateEventSpace />} />
        <RouteItem path="eventspace/edit" element={<CreateEventSpace />} />
        {/* <RouteItem path="inquiry/create" element={<CreateInquiry />} />
        <RouteItem path="inquiry/edit" element={<CreateInquiry />} /> */}
      </RouteItem>
      <RouteItem
        path="*"
        element={
          <RippleButton
            onClick={() => navigate("/")}
            style={{ margin: "20px" }}
          >
            Back to Home
          </RippleButton>
        }
      />
    </Routes>
  );
};

export default MainRouter;
